import { render, staticRenderFns } from "./QurbanCarousel.vue?vue&type=template&id=9de7b0b4"
import script from "./QurbanCarousel.vue?vue&type=script&lang=js"
export * from "./QurbanCarousel.vue?vue&type=script&lang=js"
import style0 from "./QurbanCarousel.vue?vue&type=style&index=0&id=9de7b0b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports